/*
 * @Author: wangyu
 * @since: 2023-08-29 16:15:26
 * @lastTime: 2023-11-09 18:09:54
 * @LastEditors: caiqin.xie
 * @message: 邮箱回访-隐私条款弹出框
 */
import React from "react";
import styles from "../../index.module.scss";
import { Modal} from '@arco-design/web-react';
import classNames from "classnames";

interface IProps {
    visible: boolean; // 隐私条款是否可见
    setVisible: any; // 设置显示/隐藏
    ctry: string;
    words: Record<string, string>;
    privacyClauseAgree:any; // 同意隐私条款
    privacyList: any; // 隐私条款内容
}
const PrivacyClauseModal = (props:IProps) => {
    const {visible, setVisible, ctry, words, privacyClauseAgree, privacyList} = props
    // 渲染HTML
    function creatHtml () {
        return {__html: privacyList}
    }
    return (
        <Modal
            className={styles['privacy_clause_modal']}
            title={words.support_email_us_privacy_clause}
            visible={visible}
            onOk={() => {
                setVisible(false);
            }}
            okText={words.support_email_us_agree}
            autoFocus={false}
            focusLock={true}
            onCancel={() => {
                setVisible(false);
            }}
            footer={
                <>
                    <button
                        onClick={()=>{privacyClauseAgree(true)}}
                    >
                        {words.support_email_us_agree}
                    </button>
                </>
            }
        >
            <article className={classNames(styles['privacy-article'], 'editor-wrap')} dangerouslySetInnerHTML={creatHtml()}></article>
            {/*{privacyClauseList && privacyClauseList.map(item => (*/}
                {/*<div key={item.id} className={styles['privacy_clause_list']}>*/}
                    {/*<h4 className={styles['privacy_clause_title']}>{item.id}.{words[item.title]}</h4>*/}
                    {/*<p>{words[item.content]}</p>*/}
                {/*</div>*/}
            {/*))}*/}
        </Modal>
    )
}
export default PrivacyClauseModal
